// extracted by mini-css-extract-plugin
export default {"main":"QTiwk","hidePopup":"Fqwdc","slim":"VdWFl","icon":"bhd4e","text":"hoJd1","fat":"k3n73","popup":"B5vWK"};